import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export interface CancelVDRFileUploadRequest {
    engagementId: number;
    fileId: number;
}

export const CancelVDRFileUpload = createAsyncThunk(
    'dataRoom/cancelFileUpload',
    async (
        { engagementId, fileId }: CancelVDRFileUploadRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.post(
                `api/VirtualDataRoomDocument/${engagementId}/file/${fileId}/cancel-upload`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not cancel file upload at the moment.',
                    'error'
                );
                throw new Error('Failed to cancel file upload');
            }

            return fileId;
        } catch (error) {
            createNotification(
                'An error occurred while cancelling file upload.',
                'error'
            );
            throw error;
        }
    }
);

